import React from 'react';
import { useAppSelector } from '../store/hooks';

interface SuperuserIsActiveProps {
  children?: React.ReactNode;
  className?: string;
}

// Renders its children only when superuser mode is active.
const SuperuserIsActive = ({ children, className }: SuperuserIsActiveProps) => {
  const isSuperuserActive = useAppSelector((store) => store.auth.isSuperuserActive);

  if (!isSuperuserActive) {
    return null;
  }

  return children instanceof Array
    ? <div className={className}>{children}</div>
    : <>{children}</>;
};

export default SuperuserIsActive;
